/**
 * 変更監査ログ canonical model
 *
 * creative の全書き込み経路 (API / MCP / seed) が変更前後スナップショットを
 * `creative_audit_logs` に追記する。追記専用で更新・削除しない。
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business Design Guide変更の監査ログ(誰が・いつ・何を・変更前後)のcanonicalモデル。追記専用で全書き込み経路が経由する。
 * @graph-connects none
 */
import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
/**
 * 監査対象のエンティティタイプスキーマ。
 * @graph-connects none
 */
export const CreativeEntityTypeSchema = z.enum([
    'guide_meta',
    'brand_core',
    'brand',
    'format',
    'principle',
    'checklist_category',
    'checklist_item',
    'color_token',
    'color_rule',
    'font_stack',
    'typography_rule',
    'judgment_policy',
    'ai_handoff_policy',
    'prompt_variant',
    'app_access',
]);
/**
 * 監査アクションスキーマ。
 * @graph-connects none
 */
export const AuditActionSchema = z.enum(['create', 'update', 'delete', 'seed']);
/**
 * 監査ログ 1 件の追記入力スキーマ。
 * @graph-connects none
 */
export const AuditLogInputSchema = z.object({
    entityType: CreativeEntityTypeSchema,
    entityId: z.string().min(1),
    action: AuditActionSchema,
    before: z.record(z.string(), z.unknown()).nullable(),
    after: z.record(z.string(), z.unknown()).nullable(),
    changedBy: z.string().min(1),
    changedAt: IsoDateTimeSchema,
});
/**
 * 永続化済みの監査ログスキーマ。ID は Firestore 自動採番。
 * @graph-connects none
 */
export const AuditLogEntrySchema = AuditLogInputSchema.extend({
    id: z.string().min(1),
});
//# sourceMappingURL=audit-log.js.map